import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { CoreMenuItem } from "src/app/menu/core-menu";

@Component({
    selector: "app-header-menu-accordion",
    templateUrl: "./menu-accordion.component.html",
    styleUrl: "./menu-accordion.component.scss",
    standalone: false
})
export class HeaderMenuAccordionComponent {
  @Input() menu: CoreMenuItem;
  constructor(private router: Router) {}

  calculateMenuItemCssClass(url: string): string {
    return checkIsActive(this.router.url, url) ? "active" : "";
  }
}
const getCurrentUrl = (pathname: string): string => {
  return pathname.split(/[?#]/)[0];
};

const checkIsActive = (pathname: string, url: string) => {
  const current = getCurrentUrl(pathname);
  if (!current || !url) {
    return false;
  }

  if (current === url) {
    return true;
  }

  if (current.indexOf(url) > -1) {
    return true;
  }

  return false;
};
